export default {
      id: "ic_finish_flag_green-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_finish_flag_green-usage",
      toString: function () {
        return this.url;
      }
    }